import Header from "./Header.js";
import Footer from "./Footer.js";
import { 
    Outlet, 
    useLocation 
} from "react-router-dom";
import { PAGE_LAYOUT_CONFIG } from "../../lib/config.js";
import { useScreenType } from "../../lib/hooks.js";
import { 
    useLayoutEffect, 
    useRef 
} from "react";

export default function PageLayout() {
    const { pathname } = useLocation();
    const { isMobile } = useScreenType();
    const containerRef = useRef();

    const pageSettings = PAGE_LAYOUT_CONFIG.find(page => page.pathName === pathname);
    const renderHeader = pageSettings ? (isMobile ? pageSettings.renderHeader.mobile : pageSettings.renderHeader.desktop) : true;
    const renderFooter = pageSettings ? (isMobile ? pageSettings.renderFooter.mobile : pageSettings.renderFooter.desktop) : true;

    // resets scroll position on page change
    useLayoutEffect(() => {
        containerRef.current.scrollIntoView();

    }, [pathname]);

    return (
        <div className="w-full h-screen min-h-screen overflow-y-scroll overflow-x-hidden bg-dark-three lg:bg-dark-two font-fugaz uppercase antialiased flex flex-col lg:scrollbar-hide select-none">
            { renderHeader && <Header/> }
            <main className="grow relative scroll-m-64" ref={containerRef}>
                <div className="w-full h-full z-10 relative"><Outlet/></div>
            </main>
            { renderFooter && <Footer/> }
        </div>
    )
}